import { isBrowserIe, isBrouserEdge, isBrowserIOSSafari } from './BrowserJudgment';
/**
 * 画面トップへスクロール
 */
export var scrollTop = function () {
    var logo = document.getElementsByClassName('scroll-top')[0];
    logo === null || logo === void 0 ? void 0 : logo.addEventListener('click', function (event) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
};
scrollTop();
/**
 * ナビゲーションバーを考慮し、対象要素までスクロールする
 *
 * @param element 対象要素
 * @param option 対象要素 + α の移動幅
 */
export var scrollTargetElement = function (element, option) {
    if (element === null) {
        return;
    }
    // navbarの高さを算出する
    var header = document.getElementById('navbar');
    var header_height = header !== null && typeof header !== 'undefined' ? header.clientHeight : 0;
    // ClientRectを取得する
    var client_rect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
    // 要素の高さを取得する
    var element_height = typeof client_rect !== 'undefined' ? client_rect.height : 0;
    // 座標を算出する
    var pos_y = typeof client_rect !== 'undefined' ? client_rect.top + window.pageYOffset : 0;
    if (isBrowserIe()) {
        // IE
        // NOTE IEはnavbarが追従してこないため、navbarの高さを考慮しない
        scrollTo(0, pos_y + element_height + option);
    }
    else if (isBrouserEdge() || isBrowserIOSSafari()) {
        // Edge(従来版), iOS版Safari
        scrollTo(0, pos_y + element_height - header_height + option);
    }
    else {
        scrollTo({
            top: pos_y + element_height - header_height + option,
            left: 0,
            behavior: 'smooth',
        });
    }
};
/**
 * 画面トップへスクロール
 */
export var scrollPageTop = function () {
    window.scrollTo({ top: 0, left: 0 });
};
